module.exports = {
  siteTitle: 'Hi! I\'m Sheshagiri!',
  siteDescription: `Create your online curriculum in just a few minutes with this starter`,
  keyWords: ['gatsbyjs', 'react', 'curriculum', 'sheshagiri', 'golang jobs', 'kubernetes'],
  authorName: 'Sheshagiri Rao Mallipedhi',
  twitterUsername: '_sheshagiri_',
  githubUsername: 'sheshagiri',
  authorAvatar: '/images/avatar.jpeg',
  authorDescription: `Passionate developer with keen interest for good user experience. Always interested in new technologies.
  <br>
  &nbsp;&nbsp;&nbsp;&nbsp;In 2010, right after college I started working full time as a developer writing software for backoffice trading systems. 
  In 2013, I moved on to building Network Management Systems at <i>Avaya Inc</i> where my business unit 
  was acquired by <i>Extreme Networks Inc</i> in 2017.
  <br>
  Late 2017 I joined <i>Riverbed</i> to build a Cloud Agnostic Network Functions Virtualization Orchestrator 
  using Kubernetes and spent an year there before moving back to <i>Extreme Networks</i>.
  <br>
&nbsp;&nbsp;&nbsp;&nbsp;
I currently work as a backend developer and mainly work with <strong>Go, Kubernetes, Serverless and Google Cloud Platform</strong>.`,
  skills: [
    {
      name: 'Go',
      level: 80
    },
    {
      name: 'Java/J2EE',
      level: 70
    },
    {
      name: 'Python',
      level: 42
    },
    {
      name: 'Typescript',
      level: 45
    },
    {
      name: 'Angular',
      level: 60
    },
    {
      name: 'Git',
      level: 70
    },
    {
      name: 'Docker',
      level: 70
    },
    {
      name: 'Kubernetes',
      level: 80
    },
    {
      name: 'DevOps',
      level: 80
    },
    {
      name: 'AWS/GCP',
      level: 80
    }
  ],
  jobs: [
    {
      company: "Extreme Networks Inc",
      begin: {
        month: 'oct',
        year: '2018'
      },
      duration: null,
      occupation: "Staff Software Engineer",
      description: "Building next generation cloud native network management applications."
  
    }, {
      company: "Riverbed Technology Inc",
      begin: {
        month: 'sept',
        year: '2017'
      },
      duration: '1 yr',
      occupation: "Lead Dev/Product Owner",
      description: "Involved in design and development of cloud agnostic network functions virtualization orchestrator(nfvo) using kubernetes."
    }, {
      company: "Extreme Networks Inc",
      begin: {
        month: 'Jan',
        year: '2013'
      },
      duration: '4 yrs e 9 mos',
      occupation: "Senior Software Engineer",
      description: "Responsible for design, development of various modules in network management system(nms) and sdn controller."
  
    },  {
      company: "HCL Technologies Inc",
      begin: {
        month: 'Oct',
        year: '2010'
      },
      duration: '2 yrs e 4 mos',
      occupation: "Software Engineer",
      description: "Worked for Goldman Sachs as consultant and wrote software for backoffice trading systems."
  
    }
    /* ... */
  ],
  social: {
    twitter: "https://twitter.com/_sheshagiri_",
    linkedin: "https://www.linkedin.com/in/sheshagirirao",
    github: "https://github.com/sheshagiri",
    email: "msheshagirirao@gmail.com"
  },
  siteUrl: 'https://github.com/sheshagiri',
  pathPrefix: '/sheshagiri.github.io', // Note: it must *not* have a trailing slash.
  siteCover: '/images/cover.jpeg',
  googleAnalyticsId: 'UA-146799441-1',
  background_color: '#ffffff',
  theme_color: '#25303B',
  display: 'minimal-ui',
  headerLinks: [
    {
      label: 'Sheshagiri',
      url: '/',
    }
  ]
}